import { render, staticRenderFns } from "./ModalSelectDiagnostic.vue?vue&type=template&id=5eadc37c&scoped=true"
import script from "./ModalSelectDiagnostic.vue?vue&type=script&lang=js"
export * from "./ModalSelectDiagnostic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eadc37c",
  null
  
)

export default component.exports